<template>
	<v-dialog v-model="dialog" persistent max-width="900px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-layout row wrap>
						<v-flex lg6>
							<v-select
								v-if="type == null"
								v-model="form.type"
								:items="typesOrdered"
								:error-messages="typeErrors"
								label="Type"
								item-text="text"
								item-value="value"
								required
								@change="$v.form.type.$touch()"
								@blur="$v.form.type.$touch()"
							></v-select>

							<!-- <v-select
								v-model="form.category"
								:items="categoriesOrdered"
								:error-messages="categoryErrors"
								item-text="text"
								item-value="text"
								label="Category"
								required
								@change="$v.form.category.$touch()"
								@blur="$v.form.category.$touch()"
							></v-select> -->

							<v-combobox
								:items="categoriesOrdered"
								v-model="form.category"
								chips
								label="Select a category or create a new one"
								:error-messages="categoryErrors"
								item-text="text"
								item-value="text"
								:return-object="false"
								required
								></v-combobox>

							<v-textarea v-model="subForm.item" :error-messages="itemErrors" required auto-grow rows="3" box :label="getTypeFriendly(form.type)" @input="$v.subForm.item.$touch()" @blur="$v.subForm.item.$touch()"></v-textarea>

							<v-textarea v-model="subForm.outcome" :error-messages="outcomeErrors" required auto-grow rows="3" box label="Deliverable" @input="$v.subForm.outcome.$touch()" @blur="$v.subForm.outcome.$touch()"></v-textarea>

							<div class="text-xs-right">
								<v-btn v-if="editedItemIndex > -1" @click="cancelEditItem">Cancel</v-btn>
								<v-btn v-if="editedItemIndex > -1" @click="saveItem">Save Changes</v-btn>
								<v-btn v-if="editedItemIndex == -1" @click="addItem">Add</v-btn>
							</div>

						
						</v-flex>
						<v-flex lg6>
							<v-container fluid>
								<v-data-table hide-headers disable-initial-sort :headers="headers" :items="form.items" hide-actions class="elevation-1">
									<template slot="items" slot-scope="props">
										<tr>
											<td class="text-xs-left">{{ props.item.item }}</td>
											<td class="justify-center px-0">
												<v-icon small class="mr-2" @click="editItem(props.item)">
													edit
												</v-icon>
												<v-icon small @click="deleteItem(props.item)">
													delete
												</v-icon>
											</td>
										</tr>
									</template>
								</v-data-table>

								<v-alert :value="noItemsError" color="error" icon="warning" outline>
									No items have been added
								</v-alert>
							</v-container>

							<!-- <v-btn>Add New</v-btn> -->
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="cancel">Cancel</v-btn>
					<v-btn color="primary" flat @click="submit">Save</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import { mapGetters } from 'vuex';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';

	export default {
		components: {},
		props: {
			performanceReview: {
				type: Boolean
			},
			type: {
				type: Number
			}
		},
		data() {
			return {
				dialog: true,
				types: [
					{ value: 2, text: 'Key Duty' },
					{ value: 1, text: 'KPI' },
					{ value: 3, text: '360 Discussion Point' },
					{ value: 0, text: 'General Discussion Point' }
					// { value: 3, text: 'Key Performance Measure'},
				],
				headers: [
					{ text: 'Duty', value: 'duty' },
					{ text: '', value: 'actions', sortable: false }
				],
				form: {
					id: null,
					category: null,
					items: [],
					type: this.type != null ? this.type : 2
				},
				subForm: {
					item: null,
					outcome: null
				},
				editedItemIndex: -1,
				editedItem: undefined,
				noItemsError: false
			};
		},
		computed: {
			categoryErrors() {
				const errors = [];
				if (!this.$v.form.category.$dirty) return errors;
				!this.$v.form.category.required && errors.push('Category is required.');
				return errors;
			},
			typeErrors() {
				const errors = [];
				if (!this.$v.form.type.$dirty) return errors;
				!this.$v.form.type.required && errors.push('Type is required');
				return errors;
			},
			itemErrors() {
				const errors = [];
				if (!this.$v.subForm.item.$dirty) return errors;
				!this.$v.subForm.item.required && errors.push(`${this.getTypeFriendly(this.form.type)} is required.`);
				return errors;
			},
			outcomeErrors() {
				const errors = [];
				if (!this.$v.subForm.outcome.$dirty) return errors;
				return errors;
			},
			categoriesOrdered() {
				var categories = this.categories.slice(0);
				var sorted = categories.sort();
				sorted.unshift({ id: null, text: 'N/A' });
				return sorted;
			},
			typesOrdered() {
				let types = this.types;
				if (!this.performanceReview) {
					types.splice(2, 1);
				}
				return types;
			},
			title() {
				switch (this.form.type) {
					case 0:
						return 'Add General Discussion Points';
					case 1:
						return "Add KPI's";
					case 2:
						return 'Add Key Duties';
						break;
				}
			},
			...mapGetters({
				categories: 'categories/categories'
			})
		},
		mixins: [validationMixin, typeFriendlyMixin],

		validations: {
			form: {
				category: { required },
				items: { required },
				type: { required }
			},
			subForm: {
				item: { required },
				outcome: {}
			}
		},
		methods: {
			deleteItem(item) {
				const index = this.form.items.indexOf(item);
				confirm('Are you sure you wish to delete?') && this.form.items.splice(index, 1);
			},
			editItem(item) {
				this.subForm = Object.assign({}, item);
				this.editedItemIndex = this.form.items.indexOf(item);
				this.editedItem = Object.assign({}, item);
			},
			saveItem() {
				this.$v.subForm.$touch();

				if (this.$v.subForm.$invalid) {
					
				} else {
					Object.assign(this.form.items[this.editedItemIndex], this.subForm);

					this.$v.subForm.$reset();
					this.subForm = {
						item: null,
						outcome: null
					};

					this.editedItemIndex = -1;
					this.editedItem = null;
				}
			},
			cancelEditItem() {
				this.editedItemIndex = -1;
				this.editedItem = null;

				this.$v.subForm.$reset();
				this.subForm = {
					item: null,
					outcome: null
				};
			},
			addItem() {
				this.$v.subForm.$touch();

				if (this.$v.subForm.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						item: this.subForm.item,
						outcome: this.subForm.outcome
					};

					if (this.form.items == null) {
						this.form.items = [];
					}

					this.form.items.push(postObj);

					this.$v.subForm.$reset();
					this.subForm = {
						item: null,
						outcome: null
					};
				}
			},
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');

					if (this.form.items == null || this.form.items.length == 0) {
						this.noItemsError = true;
					} else {
						this.noItemsError = false;
					}
				} else {
					let postObj = {
						category: this.form.category,
						items: this.form.items,
						type: this.form.type
					};
					this.$emit('save', postObj);
					this.closeEditor();
				}
			},
			cancel() {
				if (this.form.items != null && this.form.items.length > 0) {
					if (!confirm('You have unsaved changes, do you wish to proceed and lose these unsaved changes?')) {
						return;
					}
				}
				this.closeEditor();
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.$v.form.$reset();
				this.form.category = null;
				this.form.items = [];
			}
		}
	};
</script>

<style></style>
